import React from "react";
import PropTypes from "prop-types";
import styles from "./AccountIssueItem.module.css";
import alertIcon from "assets/alert_icon.svg";
import Button from "components/Button";
import { useTranslation } from "react-i18next";

export function AccountIssueItem({
  label,
  message,
  buttonText,
  onClick,
  hideIcon,
}) {
  const {t} = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div
          className={`${styles.labelContainer} ${
            hideIcon ? styles.noIcon : ""
          }`}
        >
          {!hideIcon && (
            <img src={alertIcon} alt={"Warning"} className={styles.icon} />
          )}
          {label && <span className={styles.label}>{t(label)}:</span>}
        </div>
        <div className={styles.messageContainer}>
          <span className={styles.description}>{message}</span>
          <div className={styles.btnContainer}>
            <Button
              buttonText={t(buttonText)}
              onClick={onClick}
              className={styles.startVerificationBtn}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

AccountIssueItem.propTypes = {
  label: PropTypes.string,
  message: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  hideIcon: PropTypes.bool, // Add hideIcon prop type
};

AccountIssueItem.defaultProps = {
  hideIcon: false,
};

export default AccountIssueItem;
